import { Component, computed, input, model } from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";

@Component({
    selector: "packbo-paginator",
    templateUrl: "./paginator.template.html",
    imports: [SvgIconComponent]
})
export class PaginatorComponent {
    public readonly currentPage = model(1);
    public readonly totalPages = input<number>(1);
    public readonly maxVisiblePages = input<number>(5);

    public readonly pages = computed(() => {
        const pages: number[] = [];
        const maxPages = this.maxVisiblePages();
        const totalPages = this.totalPages();
        const currentPage = this.currentPage();

        if (totalPages <= maxPages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            let start = Math.max(1, currentPage - Math.floor(maxPages / 2));
            const end = Math.min(totalPages, start + maxPages - 1);

            if (end - start < maxPages - 1) {
                start = Math.max(1, end - maxPages + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
        }

        return pages;
    });

    public readonly hasPrevious = computed(() => this.currentPage() > 1);

    public readonly hasNext = computed(() => this.currentPage() < this.totalPages());

    public readonly showFirstPage = computed(() => {
        const pages = this.pages();
        return pages.length > 0 && pages[0] > 1;
    });

    public readonly showLastPage = computed(() => {
        const pages = this.pages();
        return pages.length > 0 && pages[pages.length - 1] < this.totalPages();
    });

    public readonly showStartEllipsis = computed(() => {
        const pages = this.pages();
        return this.showFirstPage() && pages[0] > 2;
    });

    public readonly showEndEllipsis = computed(() => {
        const pages = this.pages();
        return this.showLastPage() && pages[pages.length - 1] < this.totalPages() - 1;
    });

    public onPageClick(page: number): void {
        if (page !== this.currentPage() && page >= 1 && page <= this.totalPages()) {
            this.currentPage.set(page);
        }
    }

    public onPreviousClick(): void {
        if (this.hasPrevious()) {
            this.currentPage.update((page) => page - 1);
        }
    }

    public onNextClick(): void {
        if (this.hasNext()) {
            this.currentPage.update((page) => page + 1);
        }
    }
}
